//location and search are props that live in all top level components in the app. So you would call (getQueryParams(this.props.location))

export function getQueryParams(location) {
  const { search } = location;

  const query = {};
  let pairs = (search[0] === "?" ? search.substr(1) : search).split("&");

  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }

  return query;
}

export function getParam(name, url, d) {
  if (!d && typeof d !== "number") d = "";
  if (!url) url = document.location.search;
  if (url.indexOf("?") > -1) url = url.slice(url.indexOf("?") + 1);
  let parts = url.split("&");
  let vals = [];
  parts.forEach((e) => {
    let param = e.split("=");
    if (param[0] === name) vals.push(param[1]);
  });
  if (vals.length === 0) return d;
  if (vals.length === 1) return vals[0];
  return vals;
}

export function removeParams(paramsToDelete = [], history) {
  let params = this.getQueryParams();
  let nextParams = [];

  paramsToDelete.forEach((param) => {
    if (params[param]) {
      delete params[param];
    }
  });

  for (let param in params) {
    if (param !== "") {
      nextParams.push(`${param}=${params[param]}`);
    }
  }

  if (nextParams.length > 0) {
    nextParams = nextParams.join("&");
    history.push({
      search: `?${nextParams}`,
    });
  } else {
    history.push({
      search: "",
    });
  }
}


import Moment from 'moment';

export const getFilterStateFromParams = (location, defaultState = {}) => {
  const query = getQueryParams(location);

  // Parse dates
  const start = query.start ? new Moment(query.start).toDate() : new Date();

  // Parse office selection
  const selectedOffice = query.office ? parseInt(query.office, 10) : -1;

  // Parse canvasser selection
  const selectedCanvasser = query.canvasser ? parseInt(query.canvasser, 10) : -1;

  // Parse event filters
  const eventTypes = ['log_in', 'log_out', 'check_in', 'check_out', 'log_response', 'site_contact_attempt',
                     'door_canvass', 'create_site', 'location_update'];

  const canvasser_events = {};
  eventTypes.forEach(type => {
    // Check if filter exists in URL and parse as boolean
    const paramValue = query[`filter_${type}`];
    if (paramValue !== undefined) {
      canvasser_events[type] = paramValue === 'true';
    } else {
      // Use default value if exists, otherwise default to true for check_in/out/response, false for others
      canvasser_events[type] = defaultState?.canvasser_events?.[type] ??
        eventTypes.includes(type);
    }
  });

  // Parse visualization mode
  const showTimeline = query.timeline === 'true';

  return {
    ...defaultState,
    start,
    selectedOffice,
    selectedCanvasser,
    canvasser_events,
    showTimeline,
    // Set to true if canvasser is selected to show the filter
    showCanvasserSelect: selectedCanvasser > -1
  };
};

export const updateUrlWithFilters = (history, state) => {
  const params = new URLSearchParams();

  // Add dates
  params.set('start', new Moment(state.start).format('YYYY-MM-DD'));

  // Add selections if not default
  if (state.selectedOffice !== -1) {
    params.set('office', state.selectedOffice);
  }

  if (state.selectedCanvasser !== -1) {
    params.set('canvasser', state.selectedCanvasser);
  }

  // Add event filters
  Object.entries(state.canvasser_events).forEach(([type, enabled]) => {
    params.set(`filter_${type}`, enabled);
  });

  // Add visualization mode
  if (state.showTimeline) {
    params.set('timeline', 'true');
  }

  // Update URL without reloading page
  history.replace({
    search: params.toString()
  });
};
